<template>
    <div :class="['picture-c',isHide&&'picture-hide']">
        <!-- 关闭按钮 -->
        <div
            :class="['close-icon', !isVertical && 'close-icon-landscape']"
            @click="closePictureMask"
        ></div>
        <swiper :options="swiperOptions" id="mySwiper" ref="mySwiper" @click.stop>
            <swiper-slide
                :class="getSwiperItemClass(item)"
                v-for="(item, index) in imgList"
                :key="index"
            >
                <img
                    :src="item.url"
                    ref="swiperImgRef"
                    :style="{ height: getImgHeight(item) }"
                    :data-isLong="getIsLongPic(item)"
                />
            </swiper-slide>
        </swiper>
        <!-- 左下角索引展示 -->
        <div class="imgs-pagination" />
        <!-- 广告 -->
        <footer class="bill-area" v-if="!isWeixin"></footer>
    </div>
</template>

<script>
import { imgReadBottomAd } from '@/ad/pages/articleAd.js';
const userAgent = navigator.userAgent
const isWeixin =  /MicroMessenger/i.test(userAgent)
const isQQ =  /QBrowser/i.test(userAgent) || /QBWebViewType/i.test(userAgent) && !/MicroMessenger/i.test(userAgent)

export default {
    props: {
        // 用户点击的图片索引
        imgindex: {
            default: 0,
            type: [Number,String]
        }
    },
    data() {
        return {
            isWeixin,
            isQQ,
            isHide: false, // true-隐藏
            activeIndex : 0, // 当前的索引值
            mySwiperRef: null,
            swiperSlideDoms: null,
            swiperImgRef: null,
            scrollTop : 0,
            originalBodyStyle : '',
            isVertical : true, // 竖屏-true 横屏-false
            isDoubleClick : false, // 是否是双击状态
            moveDistance : 0,
            moving : false,
            imgList: window.cfgs?.imageList || [],
            swiperOptions : {
                paginationClickable: true,
                pagination: '.imgs-pagination',
                paginationType: 'custom',
                preventClicks: true,
                paginationCustomRender: function (swiper, current, total) {
                    return `<span class="index-active">${current}</span>/<span class="index-total">${total}</span>`
                },
                onSlideChangeEnd: (swiper) => {
                    this.onSlideChangeEnd(swiper)
                },
                onSlideChangeStart: () => {
                    this.onSlideChangeStart()
                },
                onTouchStart: (swiper, event) => {
                    this.onTouchStart(swiper, event)
                },
                onTouchMove: (swiper, event) => {
                    this.onTouchMove(swiper, event)
                },
                onDoubleTap: (swiper, event) => {
                    this.onDoubleTap(swiper, event)
                },
                onTouchEnd: (swiper, event) => {
                    this.onTouchEnd(swiper, event)
                },
                onTab: (swiper, event) => {
                    this.onClick(swiper, event)
                },
                onClick: (swiper, event) => {
                    this.onClick(swiper, event)
                },
            }
        }
    },
    mounted() {
        this.showPictureSwiper(this.imgindex)
        window.eventBus.$on('showPictureMask',this.showPictureSwiper)
        if(!this.isWeixin && !this.isQQ){
            this.getBottomAd()
        }
    },
    methods: {
        getBottomAd() {
            imgReadBottomAd()
        },
        // 显示swiper
        showPictureSwiper(index) {
            this.activeIndex = Number(index)
            if (this.isQQ) {
                this.isHide = true
                this.handleQQBrowser(this.activeIndex)
            }else {
                window.location.hash = '#pictures'
                this.isHide = false
                // 监听浏览器返回事件，关闭遮罩
                window.addEventListener('popstate', this.closePicEvent, false)
                window.addEventListener('orientationchange', this.orientationChange, false)
                this.blockWindowScroll()
                this.$nextTick(() => {
                    this.mySwiperRef = this.$refs['mySwiper']
                    this.swiperSlideDoms = document.getElementsByClassName('swiper-slide')
                    this.swiperImgRef = this.$refs['swiperImgRef']
                    this.switchSlide(this.activeIndex)
                })
            }
        },
        // 在qq浏览器里打开图片
        handleQQBrowser(index) {
            let imgs = this.imgList
            imgs = imgs.map((item) => {
                if (!/^[http|https]/.test(item.url)) {
                    return 'https:' + item.url
                }
                return item.url
            })
            setTimeout(function () {
                window.browser &&
                    window.browser.app &&
                    window.browser.app.openPhotoBrowser &&
                    window.browser.app.openPhotoBrowser(imgs, index, 0)
            }, 0)
        },
        // 隐藏swiper
        hidePictureSwiper() {
            this.isHide = true
            window.removeEventListener('popstate', this.closePicEvent, false)
            window.removeEventListener('orientationchange', this.orientationChange, false)
            this.restoreWindowScroll()
            window.eventBus?.$emit('changeFetchAdFlag',true)
        },
        getSwiperItemClass(item) {
            return this.getIsLongPic(item) ? 'swiper-item-long' : 'swiper-item'
        },
        // 动态计算图片高度
        getImgHeight(item) {
            const w = item?.width || 0
            const h = (item?.height || 0) * 10
            let remHeight = ''
            if (w !== 0) {
                remHeight = h / w + 'rem'
            }
            return remHeight
        },
        getIsLongPic(item) {
            const w = item?.width || 0
            const h = (item?.height || 0) * 10
            let overHeight = false
            if (w !== 0) {
                overHeight = h / w > window.innerHeight / 37.5 //是否超过屏幕高度
            }
            return overHeight
        },
        /* eslint-disable */
        onClick(swiper, event) {
            if (
                !this.moving &&
                event.changedTouches &&
                event.changedTouches.length === 1 &&
                event.touches.length === 0
            ) {
                this.closePictureMask()
            }
        },
        onSlideChangeStart() {
            this.initPicScale()
            this.moving = false
        },
        // 手指移动
        onTouchMove(swiper, event) {
            let isLong = event?.target?.dataset?.islong
            if (isLong === 'true') {
                return
            }
            event.target.style.pointerEvent = 'none'
            if (this.isDoubleClick) {
                const scrollX = swiper.touches.currentX - swiper.touches.startX
                const scrollY = swiper.touches.currentY - swiper.touches.startY
                this.initSwiperSlide()
                const swiperActive = document.querySelector('.swiper-slide-active')
                const swiperPrev = document.querySelector('.swiper-slide-prev')
                const swiperNext = document.querySelector('.swiper-slide-next')
                if (swiperActive) {
                    swiperActive.style.position = 'relative'
                    swiperActive.style.zIndex = '1'
                }
                if (swiperPrev) {
                    swiperPrev.style.position = 'relative'
                    swiperPrev.style.zIndex = '-1'
                }
                if (swiperNext) {
                    swiperNext.style.position = 'relative'
                    swiperNext.style.zIndex = '-1'
                }

                event.target.style.transform = `translate3d(${scrollX}px, ${scrollY}px, 0px) scale(2)`
            } else if (event.touches.length === 2) {
                const x1 = event.touches[0].clientX
                const x2 = event.touches[1].clientX
                const y1 = event.touches[0].clientY
                const y2 = event.touches[1].clientY
                const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
                if (!this.isDoubleClick && distance > this.moveDistance) {
                    this.initSwiperSlide()
                    event.target.style.transform = 'translate3d(0px, 0px, 0px) scale(2)'
                    this.isDoubleClick = true
                }
                this.moving = true
            }
            event.preventDefault()
        },
        /* eslint-disable */
        onTouchStart(swiper, event) {
            let isLong = event?.target?.dataset?.islong
            if (isLong === 'true') {
                return
            }
            if (event.touches && event.touches.length === 2) {
                const x1 = event.touches[0].clientX
                const x2 = event.touches[1].clientX
                const y1 = event.touches[0].clientY
                const y2 = event.touches[1].clientY
                const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
                this.moveDistance = distance
                if (this.isDoubleClick && distance <= this.moveDistance) {
                    this.initSwiperSlide()
                    event.target.style.transform = 'translate3d(0px, 0px, 0px) scale(1)'
                    this.isDoubleClick = false
                }
                this.moving = true
            }
        },
        /* eslint-disable */
        onTouchEnd(swiper, event) {
            this.moving = false
            event.target.style.pointerEvent = 'auto'
        },
        // 双击放大
        /* eslint-disable */
        onDoubleTap(swiper, event) {
            let isLong = event?.target?.dataset?.islong
            if (isLong === 'true') {
                return
            }
            this.isDoubleClick = !this.isDoubleClick
            this.initSwiperSlide()
            event.target.style.transform = this.isDoubleClick
                ? 'translate3d(0px, 0px, 0px) scale(2)'
                : 'translate3d(0px, 0px, 0px) scale(1)'
        },
        initSwiperSlide() {
            for (let i = 0; i < this.swiperSlideDoms; i++) {
                this.swiperSlideDoms[i].style.transform = 'translate3d(0px, 0px, 0px)'
            }
        },
        initPicScale() {
            this.initSwiperSlide()
            this.swiperImgRef.forEach((item) => {
                item.style.transform = 'translate3d(0px, 0px, 0px) scale(1)'
            })
            this.isDoubleClick = false
        },
        // 监听屏幕转动
        orientationChange() {
            if (window.orientation === 90 || window.orientation === -90) {
                this.isVertical = false // 这是横屏
            }
            if (window.orientation === 0 || window.orientation === 180) {
                this.isVertical = true
            }
        },
        //全屏导航栏禁止屏幕滚动
        blockWindowScroll() {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            this.originalBodyStyle = document.body.style.cssText
            document.body.style.cssText +=
                'width: 100%; height: 100%; position: fixed; left: 0; top:0px; overflow: hidden;'
        },
        restoreWindowScroll() {
            document.body.style.cssText = this.originalBodyStyle
            window.scrollTo(0, this.scrollTop)
        },
        closePicEvent() {
            this.initPicScale()
            this.hidePictureSwiper()
        },
        closePictureMask() {
            this.hidePictureSwiper()
            window.history.go(-1)
        },
        // 当滑动swiper时更新当前index的值
        onSlideChangeEnd(swiper) {
            if(!this.isWeixin && !this.isQQ){
                this.getBottomAd()
            }
            this.activeIndex = swiper.activeIndex | 0
            this.isDoubleClick = false
            this.initPicScale()
        },
        // 初始化时，直接滑到用户点击的index位置
        switchSlide(index) {
            this.mySwiperRef?.swiper.slideTo(index, 0)
            this.initPicScale()
        }
    }
}
</script>

<style lang="less" scoped>
.picture-c {
    background-color: black;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    display: flex;
    align-items: center;
    .close-icon {
        position: absolute;
        left: 32px;/*px*/
        top: 32px;/*px*/
        z-index: inherit;
        width: 52px;/*px*/
        height: 52px;/*px*/
        display: inline-block;
        background: url('../../src/less/images/back.png') center center no-repeat;
        background-size: contain;
    }
    .close-icon-landscape {
        left: 28px;/*px*/
        top: 12px;/*px*/
        width: 26px;/*px*/
        height: 26px;/*px*/
    }
    #mySwiper {
        width: 100%;
        height: 70%;
        background: black;
        .swiper-item {
            display: flex;
            justify-content: center;
            align-items: center;
            .swiper-zoom-container {
                width: auto;
                height: auto;
            }
            img {
                width: 100%;
            }
        }
        .swiper-item-long {
            display: flex;
            justify-content: center;
            overflow-y: auto;
            img {
                width: 100%;
            }
        }
    }
    .imgs-pagination {
        position: absolute;
        left: 32px;/*px*/
        bottom: 180px;/*px*/
        color: white;
        font-weight: 500;
        color: #f2f2f2;
        z-index: inherit;
        font-size: 28px;/*px*/
        /deep/.index-active {
            font-size: 28px;/*px*/
        }
        .index-total {
        }
    }
    .bill-area{
        position: absolute;
        bottom: 0;
        width: 100%;
        .banner-wrapper {
            .landing-link {
                .ad-tag {
                    background: rgba(0, 0, 0,.2);
                }
            }
        }
        }
}
.picture-hide {
    display: none;
}
</style>
